<template>
  <div class="machinePartsList" v-cloak>
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane
        :label="$lange == 'en' ? 'Parts Information' : '配件信息'"
        name="machineMsg"
      >
        <div class="machineMsg">
          <div class="count-box">
            <div class="count-child flex-between total-money">
              <div class="img-box">
                <img :src="iconCoin" alt />
              </div>
              <div class="flex-between title">
                <p>
                  {{ $lange == "en" ? "Total Value (RMB)" : "总价值数（元）" }}
                </p>
                <p class="number">
                  {{ numFormat((partsInfo.totalPrice / 100).toFixed(2)) }}
                </p>
              </div>
            </div>
            <div class="count-child flex-between total-num">
              <div class="img-box">
                <img :src="iconStock" alt />
              </div>
              <div class="flex-between title">
                <p>{{ $lange == "en" ? "Total Number" : "总配件（个）" }}</p>
                <p class="number">{{ toThousands(partsInfo.partsCount) }}</p>
              </div>
            </div>
          </div>
          <el-row type="flex" justify="between" :gutter="5">
            <el-col :span="15">
              <div class="echarts-box">
                <div class="title flex-between">
                  <p>
                    {{ $lange == "en" ? "Inventory cost" : "库存成本跟踪" }}
                  </p>
                  <el-date-picker
                    v-model="stockDate"
                    value-format="yyyy"
                    align="right"
                    type="year"
                    size="mini"
                    placeholder="选择年"
                  ></el-date-picker>
                </div>
                <template v-if="isCreate">
                  <div class="not-data flex-between">
                    {{ $lange == "en" ? "No Data" : "暂无数据" }}
                  </div>
                </template>
                <template v-else>
                  <div class="echarts" id="echarts-stock"></div>
                </template>
              </div>
            </el-col>
            <el-col :span="9">
              <div class="echarts-box">
                <div class="title flex-between" style="padding: 14.5px 20px">
                  <p>
                    {{
                      $lange == "en" ? "Accessories Distribution" : "配件分布"
                    }}
                  </p>
                </div>
                <template v-if="isCreate">
                  <div class="not-data flex-between">
                    {{ $lange == "en" ? "No Data" : "暂无数据" }}
                  </div>
                </template>
                <template v-else>
                  <div
                    class="echarts"
                    id="echarts-stock-pie"
                    style="padding: 0"
                  ></div>
                </template>
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" justify="between" :gutter="5">
            <el-col :span="12">
              <div class="echarts-box">
                <div class="title flex-between">
                  <p>
                    {{
                      $lange == "en"
                        ? "Parts order amount tracking"
                        : "配件订单金额跟踪"
                    }}
                  </p>
                </div>
                <template v-if="isCreate">
                  <div class="not-data flex-between">
                    {{ $lange == "en" ? "No Data" : "暂无数据" }}
                  </div>
                </template>
                <template v-else>
                  <div class="echarts" id="echarts-shipment"></div>
                </template>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="echarts-box">
                <div class="title flex-between">
                  <p>
                    {{
                      $lange == "en"
                        ? "Warranty parts cost tracking"
                        : "保修配件成本跟踪"
                    }}
                  </p>
                </div>
                <template v-if="isCreate">
                  <div class="not-data flex-between">
                    {{ $lange == "en" ? "No Data" : "暂无数据" }}
                  </div>
                </template>
                <template v-else>
                  <div class="echarts" id="echarts-shipment-free"></div>
                </template>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane
        :label="$lange == 'en' ? 'Parts List' : '配件列表'"
        name="machineList"
      >
        <div class="machineList">
          <div class="search-group">
            <div class="input-box">
              <el-input
                size="mini"
                v-model="partsTableParams.fasCode"
                :placeholder="
                  $lange == 'en' ? 'Please Input' : '请输入FAS Code'
                "
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="input-box">
              <el-input
                size="mini"
                v-model="partsTableParams.fiCode"
                :placeholder="$lange == 'en' ? 'Please Input' : '请输入FI Code'"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <el-button type="primary" size="mini" @click="doSearch">{{
              $lange == "en" ? "Search" : "搜索"
            }}</el-button>
            <el-button
              type="primary"
              size="mini"
              @click="downloadModel"
              icon="el-icon-download"
              >{{ $lange == "en" ? "Download" : "下载模板" }}</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="insertMachine = true"
              icon="el-icon-date"
              >{{ $lange == "en" ? "Import" : "导入" }}</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="addParts = true"
              icon="el-icon-plus"
              >{{ $lange == "en" ? "Add" : "添加配件" }}</el-button
            >
          </div>
          <div class="table-box">
            <cc-table
              :config="partsTableConfig"
              :params="partsTableParams2"
              :refesh-params="refeshTable"
            ></cc-table>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="addParts"
      width="40%"
      @closed="dialogClose"
      @open="dialogOpen"
      class="partsForm"
      append-to-body
    >
      <template v-if="addParts">
        <el-form
          :model="form"
          size="mini"
          :label-width="$lange == 'en' ? '120px' : '110px'"
          :rules="formRule"
          ref="formRule"
          v-loading="formLoading"
        >
          <el-form-item :label="$lange == 'en' ? 'Image' : '配件图片'">
            <div
              class="uploaderBox"
              :style="
                'background:url(' +
                form.imageUrl +
                ') no-repeat center / cover #ccc'
              "
            >
              <!--            v-if="!config.image"-->
              <div class="upload-image">
                <cc-uploader
                  :config="uploaderConf2"
                  uploadType="dottedLine"
                  v-model="form.imageUrl"
                />
              </div>
            </div>
          </el-form-item>

          <el-form-item label="FAS Code" prop="fasCode">
            <el-input
              v-model="form.fasCode"
              :placeholder="$lange == 'en' ? 'Please Input' : '请输入FAS Code'"
            ></el-input>
          </el-form-item>

          <el-form-item label="FI Code">
            <el-input
              v-model="form.fiCode"
              :placeholder="$lange == 'en' ? 'Please Input' : '请输入FI Code'"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$lange == 'en' ? 'Name' : '配件名称'">
            <el-input
              v-model="form.partsName"
              :placeholder="$lange == 'en' ? 'Please Input' : '请输入配件名称'"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$lange == 'en' ? 'Category' : '分类'"
            prop="categoryName"
          >
            <el-select v-model="form.categoryName" clearable>
              <el-option
                v-for="item in categoryArr"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$lange == 'en' ? 'English Describe' : '英文描述'"
          >
            <el-input
              v-model="form.partsEnDescription"
              :placeholder="$lange == 'en' ? 'Please Input' : '请输入英文描述'"
            ></el-input>
          </el-form-item>

          <el-form-item
            :label="$lange == 'en' ? 'Price' : '价格'"
            prop="salePrice"
          >
            <el-input
              v-model="form.salePrice"
              type="number"
              :placeholder="$lange == 'en' ? 'Please Input' : '请输入单价'"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$lange == 'en' ? 'Cost' : '成本'" prop="price">
            <el-input
              v-model="form.price"
              type="number"
              :placeholder="$lange == 'en' ? 'Please Input' : '请输入成本'"
            ></el-input>
          </el-form-item>

          <el-form-item
            :label="$lange == 'en' ? 'FoShan' : '佛山'"
            prop="fsWarehouse"
          >
            <el-input
              v-model.number="form.fsWarehouse"
              type="number"
              :placeholder="$lange == 'en' ? 'Please Input' : '请输入库存数量'"
            ></el-input>
          </el-form-item>

          <el-form-item
            :label="$lange == 'en' ? 'TianJing' : '天津'"
            prop="tjWarehouse"
          >
            <el-input
              v-model.number="form.tjWarehouse"
              type="number"
              :placeholder="$lange == 'en' ? 'Please Input' : '请输入库存数量'"
            ></el-input>
          </el-form-item>

          <el-form-item
            :label="$lange == 'en' ? 'ShangHai' : '上海'"
            prop="shWarehouse"
          >
            <el-input
              v-model.number="form.shWarehouse"
              type="number"
              :placeholder="$lange == 'en' ? 'Please Input' : '请输入库存数量'"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$lange == 'en' ? 'ChengDu' : '成都'"
            prop="cdWarehouse"
          >
            <el-input
              v-model.number="form.cdWarehouse"
              type="number"
              :placeholder="$lange == 'en' ? 'Please Input' : '请输入库存数量'"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$lange == 'en' ? 'Consignment' : '寄售'"
            prop="consignmentSale"
          >
            <el-input
              v-model.number="form.consignmentSale"
              type="number"
              :placeholder="$lange == 'en' ? 'Please Input' : '请输入库存数量'"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$lange == 'en' ? 'Equipment' : '适用设备'">
            <el-input
              v-model="form.partsDescription"
              type="textarea"
              row="4"
              :placeholder="$lange == 'en' ? 'Please Input' : '请输入适用设备'"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$lange == 'en' ? 'Remark' : '备注'">
            <el-input
              v-model.number="form.remark"
              :placeholder="$lange == 'en' ? 'Please Input' : '请输入备注'"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="cancelForm('formRule')">{{
              $lange == "en" ? "Cancel" : "取消"
            }}</el-button>
            <el-button type="primary" @click="submitForm('formRule')">{{
              $lange == "en" ? "Submit" : "提交"
            }}</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>
    <el-dialog
      :title="$lange == 'en' ? 'Import Data' : '导入数据'"
      v-loading="dataLoading"
      :element-loading-text="$lange == 'en' ? '' : '正在导入'"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      :visible.sync="insertMachine"
      width="40%"
      @closed="dialogClose"
      append-to-body
    >
      <cc-uploader
        :config="uploaderConf2"
        :useSuccess="true"
        v-model="uploadData.accessoryUrl"
        @upload-success="uploadTrue2"
      />
      <div style="margin-top: 20px">
        <el-button size="mini" @click="insertMachine = false">{{
          $lange == "en" ? "Cancel" : "取消"
        }}</el-button>
        <el-button type="primary" size="mini" @click="insertMachineFile">{{
          $lange == "en" ? "Submit" : "提交"
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import iconCoin from "./images/icon-coin.png";
import iconStock from "./images/icon-stock.png";
import Echarts from "echarts";

export default {
  name: "MachinePartsList",
  watch: {
    stockDate: {
      handler() {
        this.stockInit();
      },
    },
  },
  data() {
    var checkNum = (rule, value, callback) => {
      console.log(value);
      if (value == undefined || value === "") {
        callback(new Error("请输入数字值"));
      } else if (value < 0) {
        callback(new Error("不能输入负数"));
      }
      {
        callback();
      }

      // else if (value % 1 !== 0) {
      //   callback(new Error("请输入整数"));
      // } else {
      //   callback();
      // }
    };
    var checkCode = (rule, value, callback) => {
      if (!value && this.form.fasCode.length < 1) {
        callback(new Error("FAS Code 跟 FI Code 必须填一个"));
      } else {
        callback();
      }
    };
    return {
      dataLoading: false,
      partsInfo: {
        partsCount: 0,
        totalPrice: 0,
        distributed: {
          consignmentSale: 0, //寄售
          tjWarehouse: 0, //天津
          fsWarehouse: 0, //佛山
          shWarehouse: 0, //上海
          cdWarehouse: 0, //成都
        },
        orderShipment: [], //订单出货
        freeShipments: [], //免费出货
      },
      uploadData: {},
      dialogTitle: "添加配件",
      insertMachine: false,
      uploaderConf2: this.$uploadUtils.config,
      isCreate: false,
      activeName: "machineMsg",
      iconCoin: iconCoin,
      iconStock: iconStock,
      stockDate: "",
      partsTableConfig: {
        api: "admin/fsb/parts/query",
        showPager: true,
        pageSize: 10,
        // dragState: true,
        columns: [
          {
            prop: "fasCode",
            lable: "FAS Code",
            type: "input",
            minWidth: 100,
          },
          {
            prop: "fiCode",
            lable: "FI Code",
            type: "input",
            minWidth: 100,
          },
          {
            prop: "imageUrl",
            lable: this.$lange == "en" ? "Image" : "图片",
            type: "img",
            urlPropName: "imageUrl",
            editAble: true,
            required: true,
            w: 30,
            h: 30,
            info: "建议图片尺寸79*79",
            sourceUrlPropName: "imageUrl",
            imgCompressParams: "?x-oss-process=image/resize,w_50",
          },
          {
            prop: "partsName",
            lable: this.$lange == "en" ? "Name" : "配件名称",
            type: "input",
          },

          {
            prop: "partsEnDescription",
            lable: this.$lange == "en" ? "English description" : "英文描述",
            minWidth: 160,
            type: "input",
          },
          {
            prop: "categoryName",
            lable: this.$lange == "en" ? "Parts category" : "配件分类",
            type: "input",
          },
          {
            prop: "warehouseNum",
            lable: this.$lange == "en" ? "Total inventory" : "库存总数",
          },
          {
            prop: "fsWarehouse",
            lable: this.$lange == "en" ? "FoShan" : "佛山",
            type: "input",
            editAble: true,
            required: true,
          },
          {
            prop: "shWarehouse",
            lable: this.$lange == "en" ? "ShangHai" : "上海",
            type: "input",
            editAble: true,
            required: true,
          },
          {
            prop: "tjWarehouse",
            lable: this.$lange == "en" ? "TianJing" : "天津",
            type: "input",
            editAble: true,
            required: true,
          },
          {
            prop: "cdWarehouse",
            lable: this.$lange == "en" ? "ChengDu" : "成都",
            type: "input",
            editAble: true,
            required: true,
          },
          {
            prop: "consignmentSale",
            lable: this.$lange == "en" ? "Consignment" : "寄售",
            type: "input",
            editAble: true,
            required: true,
          },
          {
            prop: "salePrice",
            lable: this.$lange == "en" ? "Price" : "价格",
            render: (row) => {
              return (row.salePrice / 100).toFixed(2);
              // return Math.ceil(row.salePrice / 100).toFixed(2);
            },
          },
          {
            prop: "price",
            lable: this.$lange == "en" ? "Cost" : "成本",
            render: (row) => {
              //   return Math.ceil(row.price / 100);
              return (row.price / 100).toFixed(2);
            },
          },

          {
            prop: "shipment",
            lable: this.$lange == "en" ? "Cumulative Shipment" : "累计出货",
            type: "input",
            editAble: true,
            required: true,
          },
          {
            prop: "updateTime",
            lable: this.$lange == "en" ? "Last Update" : "最近更新时间",
            minWidth: 160,
            type: "input",
            editAble: true,
            required: true,
          },
          {
            prop: "partsDescription",
            lable: this.$lange == "en" ? "Equipment" : "适用设备",
            type: "input",
            editAble: true,
            required: true,
          },
          {
            prop: "remark",
            lable: this.$lange == "en" ? "Remarks" : "备注",
            type: "input",
            editAble: true,
            required: true,
            minWidth: 160,
          },
        ],
        buttons: [
          {
            name: "编辑",
            click: (row) => {
              this.dialogTitle = "编辑配件";
              this.editPartsId = row.id;
              for (let i in this.form) {
                this.form[i] = row[i];
              }
              this.addParts = true;
            },
          },
          {
            name: "删除",
            click: (row) => {
              return (() => {
                this.$confirm("此操作会取消关联该产品, 是否确定?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    let data = {
                      id: row.id,
                    };
                    this.ccRequest
                      .do("admin/fsb/parts/delete", data, "GET")
                      .then((res) => {
                        this.$message({
                          type: "success",
                          message: "删除成功!",
                        });
                      });
                    this.refeshTable = new Date().getTime();
                  })
                  .catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                  });
              })();
            },
          },
        ],
      },
      partsTableParams: {
        fasCode: "",
        fiCode: "",
      },
      partsTableParams2: {
        fasCode: "",
        fiCode: "",
      },
      refeshTable: -1,
      addParts: false,
      categoryArr: [{ name: "分类1" }],
      formLoading: false,
      form: {
        //添加联系人的表单
        imageUrl: "",
        fasCode: "",
        fiCode: "",
        partsName: "",
        categoryName: "",
        partsEnDescription: "",
        partsDescription: "",
        salePrice: "",
        price: "",
        fsWarehouse: "",
        tjWarehouse: "",
        shWarehouse: "",
         cdWarehouse: 0, //成都
        consignmentSale: "",
        remark: "",
      },
      formRule: {
        //表单验证规则
        fasCode: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请输入 FAS Code",
          },
        ],
        // categoryName: [
        //   { required: true, trigger: ["change", "blur"], message: "请选择分类" }
        // ],
        salePrice: [
          // { validator: checkNum, required: true, trigger: ["change", "blur"] }
          { required: true, trigger: "blur", message: "请输入格" },
        ],
        price: [
          // { validator: checkNum, required: true, trigger: ["change", "blur"] }
          { required: true, trigger: "blur", message: "请输入成本" },
        ],
        fsWarehouse: [
          { validator: checkNum, required: true, trigger: ["change", "blur"] },
        ],
        tjWarehouse: [
          { validator: checkNum, required: true, trigger: ["change", "blur"] },
        ],
        cdWarehouse: [
          { validator: checkNum, required: true, trigger: ["change", "blur"] },
        ],
        shWarehouse: [
          { validator: checkNum, required: true, trigger: ["change", "blur"] },
        ],
        consignmentSale: [
          { validator: checkNum, required: true, trigger: ["change", "blur"] },
        ],
        // codeRule: [
        //     {validator: checkCode, trigger: 'blur'}
        // ],
      },
      editPartsId: false,
    };
  },

  methods: {
    doSearch() {
      this.partsTableParams2 = { ...this.partsTableParams };
    },
    downloadModel() {
      window.open(
        `${this.$apis.config.server}admin/fsb/parts/downloadPartsTemplate`
      );
    },
    insertMachineFile() {
      let fileType = this.uploadData.fileName.split(".");
      let data = {
        url: this.uploadData.accessoryUrl,
        // fileType: this.uploadData.fileName.split(".")[1],
        fileType: fileType[fileType.length - 1],
      };
      this.dataLoading = true;
      this.ccRequest
        .do("admin/fsb/parts/excelDataImport", data, "GET")
        .then((res) => {
          this.dataLoading = false;
          this.$message({
            type: "success",
            message: "导入成功",
          });
          this.refeshTable = new Date().getTime();
          this.insertMachine = false;
        })
        .catch((res) => {
          this.dataLoading = false;
          this.$message({
            type: "error",
            message: res.response.data.message,
          });
        });
    },
    uploadTrue2(res) {
      console.log(res);
      this.uploadData = res;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formLoading = true;
          let data = this.form;
          let text = "添加成功";
          if (this.editPartsId) {
            data.id = this.editPartsId;
            text = "编辑成功";
          }
          data.salePrice = Math.ceil(data.salePrice * 100);
          data.price = Math.ceil(data.price * 100);
          this.ccRequest
            .do("admin/fsb/parts/save", data, "POSTJSON")
            .then((res) => {
              this.formLoading = false;
              this.addParts = false;
              this.$message({
                message: text,
                type: "success",
              });
              this.editPartsId = false;
              this.refeshTable = new Date().getTime();
            })
            .catch((res) => {
              this.formLoading = false;
              this.$message({
                type: "error",
                message: res.response.data.message,
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    cancelForm(formName) {
      this.addParts = false;
      this.editPartsId = false;
      this.$refs[formName].resetFields();
    },
    dialogOpen() {
      // this.form.salePrice = Math.ceil(this.form.salePrice / 100);
      // this.form.price = Math.ceil(this.form.price / 100);
      this.form.salePrice = (this.form.salePrice / 100).toFixed(2);
      this.form.price = (this.form.price / 100).toFixed(2);
    },
    dialogClose() {
      this.dialogTitle = this.$lange == "en" ? "Add Parts" : "添加配件";
      for (let i in this.form) {
        this.form[i] = "";
      }
    },

    //格式化数字 每3位加逗号
    /**
     * function: toThousands
     * @n: number
     *
     **/
    toThousands(n) {
      n = ~~n;
      let num = (n || 0).toString(),
        re = /\d{3}$/,
        result = "";
      while (re.test(num)) {
        result = RegExp.lastMatch + result;
        if (num !== RegExp.lastMatch) {
          result = "," + result;
          num = RegExp.leftContext;
        } else {
          num = "";
          break;
        }
      }
      if (num) {
        result = num + result;
      }
      //   alert(result);
      return result;
    },
    numFormat(num) {
      num = num.toString().split("."); // 分隔小数点
      var arr = num[0].split("").reverse(); // 转换成字符数组并且倒序排列
      var res = [];
      for (var i = 0, len = arr.length; i < len; i++) {
        if (i % 3 === 0 && i !== 0) {
          res.push(","); // 添加分隔符
        }
        res.push(arr[i]);
      }
      res.reverse(); // 再次倒序成为正确的顺序
      if (num[1]) {
        // 如果有小数的话添加小数部分
        res = res.join("").concat("." + num[1]);
      } else {
        res = res.join("");
      }
      return res;
    },
    //各区配件库存 图表
    stockInit() {
      let data = {
        year: this.stockDate,
      };
      this.ccRequest
        .do("admin/fsb/parts/partsStock", data, "GET")
        .then((res) => {
          console.log(res, "resres");
          let valueObj = {
            consignmentSale: [],
            fsWarehouse: [],
            shWarehouse: [],
            tjWarehouse: [],
            cdWarehouse: [],
          };
          for (let j in valueObj) {
            //初始化数据
            for (let i = 0; i < 12; i++) {
              valueObj[j].push(0);
            }
          }
          for (let r in res) {
            for (let v in valueObj) {
              valueObj[v][[res[r].month - 1]] = res[r][v] / 100;
            }
          }
          console.log(valueObj, "valueObj");
          let option = {
            tooltip: {
              trigger: "axis",
              formatter: function (params, ticket, callback) {
                console.log(params);
                var res = params[0].name + "<br/>";
                for (var i = 0; i < params.length; i++) {
                  res +=
                    params[i].marker +
                    params[i].seriesName +
                    ": " +
                    params[i].value +
                    "元</br>";
                }
                return res;
              },
            },
            legend: {
              data: ["佛山", "上海", "天津", "成都", "寄售"],
            },
            grid: {
              left: "0%",
              right: "1%",
              bottom: "3%",
              containLabel: true,
            },
            xAxis: {
              type: "category",
              data: [
                "1月",
                "2月",
                "3月",
                "4月",
                "5月",
                "6月",
                "7月",
                "8月",
                "9月",
                "10月",
                "11月",
                "12月",
              ],
            },
            yAxis: {
              type: "value",
              splitLine: {
                //去除网格线
                show: false,
              },
            },
            series: [
              {
                name: "佛山",
                type: "line",
                color: "#95f204",
                data: valueObj.fsWarehouse,
              },
              {
                name: "上海",
                type: "line",
                color: "#02a7f0",
                data: valueObj.shWarehouse,
              },
              {
                name: "天津",
                type: "line",
                color: "#f59a23",
                data: valueObj.tjWarehouse,
              },
              {
                name: "成都",
                type: "line",
                color: "#f5e53f",
                data: valueObj.cdWarehouse,
              },
              {
                name: "寄售",
                type: "line",
                color: "#555555",
                data: valueObj.consignmentSale,
              },
            ],
          };
          let stockCanvas = Echarts.init(
            document.getElementById("echarts-stock")
          );
          stockCanvas.setOption(option);
        });
    },
    //配件分布 图表
    stockPieInit() {
      let data = this.partsInfo.distributed;
      let option = {
        tooltip: {
          trigger: "item",
          /**
           * @b name
           * @c value
           * @d angle
           * */
          formatter: "{b} : {c}元 ({d}%)",
        },
        legend: {
          orient: "vertical",
          right: "5%",
          top: "20%",
          // formatter: '{name}',
          data: [
            { name: "佛山", icon: "circle" },
            { name: "上海", icon: "circle" },
            { name: "天津", icon: "circle" },
            { name: "成都", icon: "circle" },
            { name: "寄售", icon: "circle" },
          ],
        },
        series: [
          {
            type: "pie",
            radius: "65%",
            center: ["40%", "50%"],
            data: [
              {
                value: data.fsWarehouse / 100,
                name: "佛山",
                label: {
                  formatter: "{b}: {c}元 \n\n {d}%",
                },
                itemStyle: {
                  color: "#95f204",
                },
              },
              {
                value: data.shWarehouse / 100,
                name: `上海`,
                label: {
                  formatter: "{b}: {c}元 \n\n {d}%",
                },
                itemStyle: {
                  color: "#02a7f0",
                },
              },
              {
                value: data.tjWarehouse / 100,
                name: `天津`,
                label: {
                  formatter: "{b}: {c}元 \n\n {d}%",
                },
                itemStyle: {
                  color: "#f59a23",
                },
              },
              {
                value: data.cdWarehouse / 100,
                name: `成都`,
                label: {
                  formatter: "{b}: {c}元 \n\n {d}%",
                },
                itemStyle: {
                  color: "#f5e53f",
                },
              },
              {
                value: data.consignmentSale / 100,
                name: `寄售`,
                label: {
                  formatter: "{b}: {c}元 \n\n {d}%",
                },
                itemStyle: {
                  color: "#555555",
                },
              },
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      let stockPicCanvas = Echarts.init(
        document.getElementById("echarts-stock-pie")
      );
      stockPicCanvas.setOption(option);
    },
    //近12个月订单出货量 图表
    shipmentInit() {
      let data = this.partsInfo.orderShipment;
      //partsNum 发货件数
      //partsTotalPrice 配件总价
      let shippingValue = [];
      let priceValue = [];
      for (let i = 0; i < 12; i++) {
        shippingValue.push(0);
        priceValue.push(0);
      }
      for (let i in data) {
        let item = data[i];
        shippingValue[item.month - 1] = item.partsNum;
        priceValue[item.month - 1] = item.partsTotalPrice / 100;
      }
      let option = {
        tooltip: {
          // axisPointer: {
          //     type: 'line',
          // },
        },
        grid: {
          left: "5%",
          right: "5%",
        },
        legend: {
          data: ["收费出货价值", "出货件数"],
        },
        xAxis: [
          {
            type: "category",
            data: [
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
              "12月",
            ],
            axisPointer: {
              type: "shadow",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "价值",
            min: 0,
            // interval: 1000, //可设置数据间隔
            axisLabel: {
              formatter: "{value}",
            },
            splitLine: {
              //去除网格线
              show: false,
            },
          },
          {
            type: "value",
            name: "件数",
            min: 0,
            // interval: 5,
            axisLabel: {
              formatter: "{value}",
            },
            splitLine: {
              //去除网格线
              show: false,
            },
          },
        ],
        series: [
          {
            name: "收费出货价值",
            type: "line",
            data: priceValue,
            itemStyle: {
              color: "#02a7f0",
            },
          },
          {
            name: "出货件数",
            type: "bar",
            yAxisIndex: 1,
            data: shippingValue,
            itemStyle: {
              color: "#ccc",
            },
          },
        ],
      };
      let shipmentCanvas = Echarts.init(
        document.getElementById("echarts-shipment")
      );
      shipmentCanvas.setOption(option);
    },
    //近12个月免费出货量 图表
    shipmentFreeInit() {
      let data = this.partsInfo.freeShipments;
      //partsNum 发货次数
      //partsTotalPrice 配件总价
      let numValue = [];
      let priceValue = [];
      for (let i = 0; i < 12; i++) {
        numValue.push(0);
        priceValue.push(0);
      }
      for (let i in data) {
        let item = data[i];
        numValue[item.month - 1] = item.partsNum;
        priceValue[item.month - 1] = item.partsTotalPrice / 100;
      }
      let option = {
        tooltip: {
          // axisPointer: {
          //     type: 'cross',
          //     crossStyle: {
          //         color: '#999'
          //     }
          // }
        },
        grid: {
          left: "5%",
          right: "5%",
        },
        legend: {
          data: ["免费出货价值", "出货件数"],
        },
        xAxis: [
          {
            type: "category",
            data: [
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
              "12月",
            ],
            axisPointer: {
              type: "shadow",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "价值",
            min: 0,
            axisLabel: {
              formatter: "{value}",
            },
            splitLine: {
              //去除网格线
              show: false,
            },
          },
          {
            type: "value",
            name: "件数",
            min: 0,
            axisLabel: {
              formatter: "{value}",
            },
            splitLine: {
              //去除网格线
              show: false,
            },
          },
        ],
        series: [
          {
            name: "免费出货价值",
            type: "line",
            data: priceValue,
            itemStyle: {
              color: "#f59c27",
            },
          },
          {
            name: "出货件数",
            type: "bar",
            yAxisIndex: 1,
            data: numValue,
            itemStyle: {
              color: "#ccc",
            },
          },
        ],
      };
      let shipmentCanvas = Echarts.init(
        document.getElementById("echarts-shipment-free")
      );
      shipmentCanvas.setOption(option);
    },
    initEcharts() {
      let year = `${new Date().getFullYear()}`;
      this.stockDate = year;
      this.stockPieInit();
      this.shipmentInit();
      this.shipmentFreeInit();
    },

    getData() {
      this.ccRequest.do("admin/fsb/parts/partsInfo", {}, "GET").then((res) => {
        this.partsInfo = res;
        this.initEcharts();
      });
    },
  },
  mounted() {
    this.getData();
    // this.checkLanguage();
  },
};
</script>

<style scoped lang="scss">
.machinePartsList {
  background: #ffffff;

  .machineMsg {
    padding: 20px;
    .count-box {
      display: flex;

      .count-child {
        border: 1px solid #e4e4e4;
        padding: 20px 30px;
        border-radius: 5px;
        justify-content: center;
        margin-right: 20px;

        .img-box {
          background: #49a9ee;
          border-radius: 50%;
          padding: 10px;
          margin-right: 15px;

          img {
            display: block;
            width: 40px;
          }
        }

        .title {
          height: 75%;
          align-items: flex-start;
          flex-direction: column;
          color: #b5b5b5;
          .number {
            color: #666666;
          }
        }

        &.total-num {
          .img-box {
            background: #f3857c;
          }
        }
      }
    }

    .echarts-box {
      margin-top: 20px;
      background: #ffffff;
      border: 1px solid #e4e4e4;
      /*标题*/
      .title {
        border-bottom: 1px solid #e4e4e4;
        padding: 10px 20px;
      }

      /*图表*/
      .echarts {
        padding: 20px;
        height: 360px;
        width: 100%;
        box-sizing: border-box;
      }

      /*表格内容*/
      .lists {
        height: 360px;
        overflow: auto;
        padding: 0 20px;

        p {
          min-width: 80px;
        }

        & > * > p {
          padding: 10px 0;

          &:last-child {
            flex: 1;
          }

          &:first-child {
            text-align: center;
          }

          &:nth-child(2) {
            margin: 0 10px;
          }
        }

        .list-child-wid {
          width: 120px;
        }

        .list-title {
          color: #cccccc;
          border-bottom: 1px solid #e4e4e4;
        }

        .list-context {
          &:not(:last-child) {
            border-bottom: 1px solid #e4e4e4;
          }

          .list-progress {
            span {
              margin-right: 10px;
            }
          }
        }
      }

      /*无数据的时候显示*/
      .not-data {
        height: 360px;
        justify-content: center;
        font-size: 22px;
        color: #e4e4e4;
      }
    }
  }
  .machineList {
    background: #fff;
    padding: 20px;
    .input-box {
      margin-right: 20px;
    }
    .search-group {
      display: flex;
      margin-bottom: 20px;
    }
  }
}
</style>
<style lang="scss">
.partsForm {
  .dottedUpload {
    min-width: 100px;
  }
  .uploaderBox {
    width: 100px;
    height: 100px;
    position: relative;
  }
}
</style>
